import {DatabaseInfo, DatabaseProperty} from "@app/core-app/app/data/notion/DatabaseInfo";
import {PageData} from "@app/core-app/app/usecase/notion/fetch-pages";
import logger from "@app/core-app/logger";

export const getDateValue = (page: any, database: DatabaseInfo): string | null | undefined => {
  const sendAtProp = database.outboxConfig.report.sendAt
  const property = sendAtProp.ok ? sendAtProp.name : null

  if (!property) {
    return null
  }

  const prop = page.properties[property]
  const isDate = prop?.type === "date"

  if (!isDate) {
    return null
  }
  const time = prop.date?.start

  return time
}

export const getInReplyToValue = (page: any, database: DatabaseInfo): string[] | null | undefined => {
  if(database.outboxConfig.type != "v2"){
    return null
  }
  const inReplyToProp = database.outboxConfig.report.inReplyTo
  const property = inReplyToProp.ok ? inReplyToProp.name : null

  if (!property) {
    return null
  }

  const prop = page.properties[property]

  if(prop.type === "relation"){
    const relations = prop.relation;
    return relations
  }else {
    return null
  }

}


export const shouldDeliverPage = (page: PageData): boolean => {
  let shouldBeSent = true

  if (page.sendAt) {
    try {
      const date = new Date(page.sendAt)
      const now = new Date()
      shouldBeSent = now > date
    } catch (e) {
      // logger.error({e: e, msg: "Send At date formatting error"})
    }
  }

  return shouldBeSent
}

export const mapFiles = (page: any, database: DatabaseInfo): Array<any> => {
  // Assuming that the files are stored under a property named "files"
  const properties = page.properties
  const property = database.outboxConfig.report.attachments.ok ? database.outboxConfig.report.attachments.name : null
  if (!property) {
    return []
  }
  const filesProp = properties[property];
  const isFiles = filesProp?.type === "files";

  if (!isFiles || !filesProp?.files) {
    return [];
  }

  return filesProp.files
    .filter((file: any) => file?.file?.url)
    .map((file: any) => ({
      name: file.name,
      type: file.type,
      file: {
        url: file?.file?.url,
        expiry_time: file?.file?.expiry_time,
      },
    }));
};


export const getNonReservedPropertiesNames = (database: DatabaseInfo): string[] => {
  const reservedProperties = [
    database.inboxReport.attachmentsProperty,
    database.inboxReport.toProperty,
    database.inboxReport.fromProperty,
    database.inboxReport.dateReceivedProperty,
    database.inboxReport.nameProperty,
    database.inboxReport.emailImageProperty,
    database.inboxReport.previewImageProperty,
    database.inboxReport.replyToProperty,
    database.inboxReport.emailTextProperty
  ]

  const props = database.propertiesObjects
    .filter((p: DatabaseProperty) => !reservedProperties.includes(p.name))
    .map((p: DatabaseProperty) => p.name)

  return props

}
